module.exports = __webpack_public_path__ + "static/media/banner-back.85b77a04.png";